import { onDocumentReady } from "@story/story_assets";

class Typing {
	constructor(element) {
		this.element = element;
		this.options = JSON.parse(element.getAttribute("data-typing"));
		this.activeIndex = 0;
		this.direction = -1;
		this.str = this.options[this.activeIndex];
		this.start();
	}

	tick() {
		if (this.direction < 0) {
			if (0 < this.str.length) {
				this.str = this.str.slice(0, -1);
			}
			else {
				this.direction = 1;
				this.activeIndex = (this.activeIndex + 1) % this.options.length;
			}
		}
		else {
			let currentStr = this.options[this.activeIndex];
			if (this.str.length < currentStr.length) {
				this.str = currentStr.slice(0, this.str.length + 1);
			}
			else {
				this.direction = -1;
				this.wait();
			}
		}

		this.element.innerText = this.str;
	}

	start() {
		this.interval = setInterval(this.tick.bind(this), 100);
	}

	wait() {
		let self = this;
		clearInterval(this.interval);
		setTimeout(function() {
			self.start();
		}, 1500);
	}
}

onDocumentReady(function() {
	for (let element of document.querySelectorAll("[data-typing]")) {
		new Typing(element);
	}
});
